export function parseHashArray(hash: string, delimiter = ","): { [k: string]: string[] } {
	let result = {};
	if (hash === "") {
		return result;
	}

	const parts = hash.substr(1).split("&");

	parts.forEach(part => {
		const [key, array] = part.split("=");
		result[key] = array.split(delimiter);
	});

	return result;
}
